import { render, staticRenderFns } from "./AboutUsView.vue?vue&type=template&id=046ecf2c&scoped=true"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"
import style0 from "./AboutUsView.vue?vue&type=style&index=0&id=046ecf2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046ecf2c",
  null
  
)

export default component.exports